import _ from 'lodash';
import React from 'react';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';

import addImage from './assets/add.svg';
import wrongFormatImage from 'assets/icons/reject.svg';

import './styles.css';

const DropzoneUpload = ({
  onDrop,
  multiple,
  wrongFormat,
  acceptedFileTypes,
  defaultComponent,
  onDrag,
  disableClick
}) => (
  /*
    `acceptedFileTypes` must be string. If you want to pass more than
    just one accepted file type separate the types with comma. Example:
      - Single file type: ".jpg"
      - Multiple file types: ".jpg, .png, .pdf"
    If `acceptedFileTypes` isn't passed then all file types will be accepted

    Useful links:
      - Dropzone docs & examples: https://react-dropzone.js.org
      - Dropzone props: https://react-dropzone.netlify.com/#proptypes
  */
  <Dropzone
    className={classNames('DropzoneUpload', {
      defaultComponent,
      'colab-clickable': !disableClick
    })}
    accept={acceptedFileTypes}
    onDrop={onDrop}
    onDragEnter={onDrag}
    multiple={multiple}
    disableClick={disableClick}>
    {defaultComponent}
    {_.isNil(defaultComponent) && (
      <div className="DropzoneUploadContainer">
        {wrongFormat && <img src={wrongFormatImage} alt="Wrong Format" />}
        {!wrongFormat && <img src={addImage} alt="Add" />}
        <p className="DropzoneUploadText">
          {wrongFormat && 'Unsupported file type'}
          {!wrongFormat && 'Drag and drop or click here to upload'}
        </p>
      </div>
    )}
  </Dropzone>
);

export default DropzoneUpload;
